<template>
  <div>
    <TrackingLogList :sms-campaign-id="smsCampaign.id" />
  </div>
</template>

<script>
import TrackingLogList from './components/TrackingLogList.vue';

export default {
  components: { TrackingLogList },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
};
</script>
